import { c as _c } from "react/compiler-runtime";
import type { SelectOptionType } from '@systemeio/tip-tap';
import { getContactFieldTitle, useTranslation as useUtilTranslation } from '@systemeio/util';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import type { ReactNode } from 'react';
import { Hint } from 'shared/components';
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface SubstituteOption extends SelectOptionType<string> {
  hint?: ReactNode;
}
export const useSubstitutes = t0 => {
  const $ = _c(23);
  const additionalSubstitutes = t0 === undefined ? [] : t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUtil
  } = useUtilTranslation();
  const {
    fields: substitutes
  } = useContactFields();
  const additionalSubstitutionData = additionalSubstitutes.map(_temp);
  let t1;
  if ($[0] !== tUtil) {
    t1 = el_0 => ({
      value: `{${el_0.slug}}`,
      label: getContactFieldTitle(el_0, tUtil)
    });
    $[0] = tUtil;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contactSubstitutionData = (substitutes?.items ?? []).map(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      a: <span className="block pl-3" />,
      b: <b />
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = <TransLoco t={t} i18nKey="dashboard.email.clickable_url_description" components={t2} />;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const affiliateDashboardHint = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.email.contact_affiliate_id");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      label: t4,
      value: "{affiliate_id}"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("dashboard.email.contact_affiliate_url");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.email.contact_affiliate_url");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== affiliateDashboardHint || $[14] !== t7) {
    t8 = <Hint inline={true} passive={true} side="right" label={affiliateDashboardHint}>{t7}</Hint>;
    $[13] = affiliateDashboardHint;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== affiliateDashboardHint || $[17] !== t6 || $[18] !== t8) {
    t9 = {
      label: t6,
      hint: affiliateDashboardHint,
      customLabel: t8,
      value: "{affiliate_dashboard}"
    };
    $[16] = affiliateDashboardHint;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t9) {
    t10 = [t5, t9];
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const affiliateSubstitutionData = t10;
  const substitutionData = [...additionalSubstitutionData, ...contactSubstitutionData, ...affiliateSubstitutionData];
  const isReady = !!substitutes;
  return {
    substitutionData,
    isReady
  };
};
function _temp(el) {
  return {
    value: `{${el.slug}}`,
    label: el.name
  };
}